import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./WarningCardModal.module.css";
import classNames from "classnames";
import { Button } from "../Button/Button";
import { useTranslation } from "react-i18next";

/**
 * Basic layout for modals used in the app
 */

export function WarningCardModal({ isOpen, title, description, onClick }) {
  const {t} = useTranslation();
  return (
    <>
      {isOpen && (
        <div className={styles.overlay}>
          <div className={styles.container}>
            <div className={styles.content}>
              <p className={styles.title}>{title}</p>
            </div>
            <div className={styles.cancel}>
              <Button buttonText={t("Okay")} onClick={onClick} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

WarningCardModal.propTypes = {
  /**
   * Boolean to determine if modal is open
   */
  isOpen: PropTypes.bool,
  /**
   * Function called to close modal
   */
  onClose: PropTypes.func,
  /**
   * Children components to render in the modal
   */
};
